var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStaffDefaultRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    rx: 90,
    fill: "#CAD3C0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_17863_225545",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 180,
    height: 180
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    rx: 90,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_17863_225545)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.3636 122.73C132.914 122.73 166.364 155.746 166.364 196.757C166.364 201.06 162.875 204.549 158.572 204.549H24.1556C19.8522 204.549 16.3636 201.06 16.3636 196.757C16.3636 155.746 49.8137 122.73 91.3636 122.73ZM90.0004 32.7305C109.581 32.7307 125.454 48.6039 125.454 68.1846C125.454 87.7654 109.581 103.639 90.0004 103.64C70.4192 103.64 54.5453 87.7655 54.5453 68.1846C54.5455 48.6038 70.4194 32.7305 90.0004 32.7305Z",
    fill: "#E0EAD5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaffDefaultRounded);
export default __webpack_public_path__ + "static/media/staff-default-rounded.81aa4d15f772fa67fd79b484b5f9aede.svg";
export { ForwardRef as ReactComponent };